export default [
  {
    path: '/fail',
    name: 'Fail',
    component: () => import('@/pages/user/Fail'),
    meta: { anonymous: true }
  },
  {
    path: '/notWeChat',
    name: 'NotWeChat',
    component: () => import('@/pages/user/NotWeChat'),
    meta: { anonymous: true }
  },
  {
    path: '/expires',
    name: 'Expires',
    component: () => import('@/pages/user/expires'),
    meta: { anonymous: true }
  },
  {
    path: '/login/:code?',
    name: 'Login',
    component: () => import('@/pages/user/login'),
    meta: { anonymous: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/user/register'),
    meta: { anonymous: true }
  },
  {
    path: '/noAuth',
    name: 'NoAuth',
    component: () => import('@/pages/user/noAuth'),
    meta: { anonymous: true }
  },
  {
    path: '/user/info',
    name: 'UserInfo',
    component: () => import('@/pages/user/info')
  }
]



// WEBPACK FOOTER //
// ./src/router/user/index.js